import React from 'react'
import NextSection from './components/NextSection'
import ModelViewer from './components/ModelViewer'
import minilogo from '../../assets/Images/stream-mini-logo.png'

const RenderAR = () => {
  return (
    <>
      <div className="logo">
        <img src={minilogo} alt="Stream logo" />
      </div>
      <ModelViewer />
      <NextSection />
    </>
  )
}

export default RenderAR
